import axios from "axios";

import {
  ActiveConfigInfo,
  ConfigNameAndDescription,
  SiteAppModule,
  SiteControlModule,
} from "./AppConfigModels";
import APP_CONFIG from "../app/configuration/AppConfig";

const baseUrl = APP_CONFIG.serviceUrls.siteAppsConfigUrlPrefix;

export async function getConfigListAsync(
  siteId: string,
  configVersion: string,
  siteApp: SiteAppModule,
  signal?: AbortSignal
) {
  const url = `${baseUrl}/Query`;
  const params = {
    siteId: siteId,
    configVersionFilter: configVersion,
    siteApp: siteApp,
  };
  const httpResponse = await axios.request<ConfigNameAndDescription[]>({
    url,
    params,
    signal,
  });
  return httpResponse.data;
}

export async function getConfigResourceAsync(resource: string, siteApp: SiteAppModule) {
  const url = `${baseUrl}/Resource/${resource}/${siteApp}`;
  const httpResponse = await axios.request<Uint8Array>({
    url,
    responseType: "arraybuffer",
  });
  return httpResponse.data;
}

//uploads new config file and returns the id of the new file
export async function uploadConfigResourceAsync(
  siteId: string,
  configSchemaVersion: string,
  fileData: Uint8Array,
  siteApp: SiteAppModule
) {
  const url = `${baseUrl}/Resource/${siteId}_${configSchemaVersion}/${siteApp}`;
  const params = { file: fileData };
  const headers = { headers: { "Content-Type": "multipart/form-data" } };
  const newFileId = await axios.post<string>(url, params, headers);
  return newFileId.data;
}

export async function setActiveConfigResourceAsync(resource: string, siteApp: SiteAppModule) {
  const url = `${baseUrl}/Active/${resource}/${siteApp}`;
  await axios.post<void>(url);
}

export async function updateConfigFileMetadataAsync(
  resource: string,
  siteApp: SiteAppModule,
  description: string,
  uploadedBy: string
) {
  const url = `${baseUrl}/Resource/Metadata/${resource}/${siteApp}`;
  const params = { description: description, uploadedBy };
  return await axios.post(url, params);
}

export async function deleteConfigResourceAsync(resource: string, siteApp: SiteAppModule) {
  const url = `${baseUrl}/Resource/${resource}/${siteApp}`;
  return await axios.delete(url);
}

export async function getActiveConfigInfoAsync(
  siteId: string,
  siteApp: SiteAppModule,
  signal?: AbortSignal
): Promise<ActiveConfigInfo | null> {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/siteAppConfigs/${siteId}/${siteApp}/active/info`;
  const httpResponse = await axios.get<ActiveConfigInfo>(url, {
    signal,
    validateStatus: (status) => status === 200 || status === 404,
  });
  if (httpResponse.status === 404) {
    return null;
  }
  return httpResponse.data;
}

export async function getActiveConfigsGeneratedStatusAsync(
  siteApp: SiteControlModule
): Promise<Record<string, boolean>> {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/siteAppConfigs/${siteApp}/active/generated`;
  const response = await axios.get<Record<string, boolean>>(url);
  return response.data;
}
